<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form :model="queryParams" ref="ssqForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="起始期数">
        <el-input v-model="queryParams.startPeriod" placeholder="开始期数" clearable style="width: 100px;"/>
        -
        <el-input v-model="queryParams.endPeriod" placeholder="结束期数" clearable style="width: 100px;"/>
      </el-form-item>
      <el-form-item label="红球1" prop="redOne">
        <el-input v-model="queryParams.redOne" placeholder="红球1" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="红球2" prop="redTwo">
        <el-input v-model="queryParams.redTwo" placeholder="红球2" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="红球3" prop="redThree">
        <el-input v-model="queryParams.redThree" placeholder="红球3" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="红球4" prop="redFour">
        <el-input v-model="queryParams.redFour" placeholder="红球4" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="红球5" prop="redFive">
        <el-input v-model="queryParams.redFive" placeholder="红球5" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="红球6" prop="redSix">
        <el-input v-model="queryParams.redSix" placeholder="红球6" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item label="蓝球" prop="blueOne">
        <el-input v-model="queryParams.blueOne" placeholder="蓝球" clearable style="width: 80px;"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuerySsq">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuerySsq">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:ssq:init']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleInitAllSsq">全部初始化
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:ssq:fill']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleFillSsqHistory">
          补全历史数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:ssq:count']" type="danger" plain icon="el-icon-data-line" size="mini" @click="handleSsqDataLine">号码频率
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:ssq:export']" type="warning" plain icon="el-icon-export" size="mini" @click="handleExportSsq">导出</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:ssq:initC']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleInitAllSsqC">
          初始化统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:ssq:exportC']" type="warning" plain icon="el-icon-export" size="mini" @click="handleOpenC()">导出统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:ssq:cache']" type="danger" plain icon="el-icon-export" size="mini" @click="handleRefreshSsq">刷新缓存</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:ssq:gen']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleOpenGenerateSsq">
          生成双色球
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:ssq:exportF']" type="warning" plain icon="el-icon-export" size="mini" @click="exportFrequency">导出组合频率
        </el-button>
      </el-col>
      <right-toolbar :show-search.sync="showSearch" @queryTable="getSsqList" />
    </el-row>
    <el-table :data="ssqList" v-loading="loading" border highlight-current-row
              :cell-class-name="cellClassName">
      <el-table-column label="期号" align="center" prop="period"/>
      <el-table-column label="红球号码" align="center">
        <el-table-column label="1" align="center" prop="redOne"/>
        <el-table-column label="2" align="center" prop="redTwo"/>
        <el-table-column label="3" align="center" prop="redThree"/>
        <el-table-column label="4" align="center" prop="redFour"/>
        <el-table-column label="5" align="center" prop="redFive"/>
        <el-table-column label="6" align="center" prop="redSix"/>
      </el-table-column>
      <el-table-column label="蓝球" align="center" prop="blueOne"/>
      <el-table-column label="奖池金额" align="right" prop="pondAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatYuan(scope.row.pondAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="一等奖" align="center">
        <el-table-column label="注数" align="center" prop="firstCount"/>
        <el-table-column label="奖金(元)" align="right" prop="firstAmount" min-width="90px">
          <template slot-scope="scope">
            {{ formatYuan(scope.row.firstAmount) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="二等奖" align="center">
        <el-table-column label="注数" align="center" prop="secondCount"/>
        <el-table-column label="奖金(元)" align="right" prop="secondAmount">
          <template slot-scope="scope">
            {{ formatYuan(scope.row.secondAmount) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="销售金额" align="right" prop="saleAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatYuan(scope.row.saleAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="开奖日期" align="center" prop="lotteryDate" min-width="90px">
        <template slot-scope="scope">
          {{ scope.row.lotteryDate | date }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="210px">
        <template slot-scope="scope">
          <el-button v-hasPermi="['lottery:ssq:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
          <el-button v-hasPermi="['lottery:ssq:next']" type="text" icon="el-icon-medal" @click="handleNextHistory(scope.row.period)">下期</el-button>
          <el-button v-hasPermi="['lottery:ssq:nextF']" type="text" icon="el-icon-medal" @click="handleNextNum(scope.row.period)">频率</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getSsqList"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
    />
    <!-- 数字次数图表弹出层 -->
    <el-dialog :title="countTitle" :visible.sync="countOpen" width="1500px" @closed="countClosed"
               :close-on-click-modal="false">
      <div ref="redChart" style="width:100%;height: 300px;"></div>
      <div ref="blueChart" style="width:100%;height: 300px;margin-top: 20px"></div>
    </el-dialog>
    <!-- 导出统计次数弹出层 -->
    <el-dialog :title="cTitle" :visible.sync="cOpen" width="300px" :close-on-click-modal="false">
      <el-form ref="cForm" :model="cForm" :rules="cRules" label-width="110px" label-suffix="：">
        <el-form-item prop="isC">
                    <span slot="label">
                      是否排序
                      <el-popover
                        placement="top-start"
                        width="250"
                        trigger="hover"
                        content="如果排序为是，导出数据号码为历史出现次数从多到少的顺序;否则按照数据号码从小到大排序">
                        <i slot="reference" class="el-icon-question"></i>
                      </el-popover>
                    </span>
          <el-select v-model="cForm.isC" placeholder="请选择是否" style="width: 140px">
            <el-option :key="true" label="是" :value="true"></el-option>
            <el-option :key="false" label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportC">导出</el-button>
        <el-button @click="cancelC">取消</el-button>
      </div>
    </el-dialog>
    <!-- 生成双色球弹出层 -->
    <el-dialog title="生成双色球" :visible.sync="generateSsqOpen" width="750px" :close-on-click-modal="false">
      <el-form ref="generateSsqForm" :model="generateSsqForm" :inline="true" :rules="generateSsqRules"
               label-width="80px">
        <el-form-item label="生成个数" prop="count">
          <el-select v-model="generateSsqForm.count" placeholder="请选择个数">
            <el-option :key="1" label="1" :value="1"/>
            <el-option :key="5" label="5" :value="5"/>
            <el-option :key="10" label="10" :value="10"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleGenerateSsq">生成</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetGenerateSsq">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="generateSsqList" border style="width: 100%" :cell-class-name="cellClassName"
                highlight-current-row>
        <el-table-column label="红球号码" align="center">
          <el-table-column label="1" align="center" prop="redOne"/>
          <el-table-column label="2" align="center" prop="redTwo"/>
          <el-table-column label="3" align="center" prop="redThree"/>
          <el-table-column label="4" align="center" prop="redFour"/>
          <el-table-column label="5" align="center" prop="redFive"/>
          <el-table-column label="6" align="center" prop="redSix"/>
        </el-table-column>
        <el-table-column label="蓝球" align="center" prop="blueOne"/>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-hasPermi="['lottery:ssq:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 往期中奖概率弹出层 -->
    <el-dialog title="往期中奖概率" :visible.sync="winningOpen" width="500px">
      <el-row :gutter="20" v-for="(item,index) in winningList" :key="index" style="padding: 5px 0">
        <el-col :span="8">{{ item.name }}</el-col>
        <el-col :span="8">注数：{{ item.count }}</el-col>
        <el-col :span="8">概率：{{ formatMoney(item.winningRate * 100, 2) }}%</el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="winningOpen=false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 下期双色球同期历史数据弹出层 -->
    <el-dialog :title="ssqHistoryTitle" :visible.sync="ssqHistoryOpen" width="1500px" :close-on-click-modal="false">
      <el-tabs v-model="activeSsqHistoryName" type="border-card">
        <el-tab-pane label="历史同期数据" name="firstSsq">
          <el-table :data="ssqHistoryList" border style="width: 100%" :cell-class-name="cellClassName"
                    highlight-current-row>
            <el-table-column label="期数" align="center" prop="period" width="70"/>
            <el-table-column label="红球号码" align="center">
              <el-table-column label="1" align="center" prop="redOne" width="60"/>
              <el-table-column label="2" align="center" prop="redTwo" width="60"/>
              <el-table-column label="3" align="center" prop="redThree" width="60"/>
              <el-table-column label="4" align="center" prop="redFour" width="60"/>
              <el-table-column label="5" align="center" prop="redFive" width="60"/>
              <el-table-column label="6" align="center" prop="redSix" width="60"/>
            </el-table-column>
            <el-table-column label="蓝球" align="center" prop="blueOne" width="60"/>
            <el-table-column label="和值" align="center">
              <el-table-column label="红球" align="center" prop="redSum" width="60"/>
              <el-table-column label="总和" align="center" prop="totalSum" width="60"/>
            </el-table-column>
            <el-table-column label="红球跨度" align="center" prop="redSpan" width="70"/>
            <el-table-column label="红球奇数" align="center" prop="redOdd" width="70"/>
            <el-table-column label="红球偶数" align="center" prop="redEven" width="70"/>
            <el-table-column label="序号区间" align="center">
              <el-table-column label="一区(1-11)" align="center" prop="n1" width="100px"/>
              <el-table-column label="二区(12-22)" align="center" prop="n2" width="100px"/>
              <el-table-column label="三区(23-33)" align="center" prop="n3" width="100px"/>
            </el-table-column>
            <el-table-column label="次数区间" align="center">
              <el-table-column label="一区" align="center" prop="m1"/>
              <el-table-column label="二区" align="center" prop="m2"/>
              <el-table-column label="三区" align="center" prop="m3"/>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="统计数据" name="secondSsq">
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">红球次数排名：</el-col>
            <el-col :span="22">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in ssqHistoryRedList" :key="item.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">未出现的红球：</el-col>
            <el-col :span="22"><span v-for="item in ssqHistoryRedZeroList" :key="item">{{ item }} </span></el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">蓝球次数排名：</el-col>
            <el-col :span="22">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in ssqHistoryBlueList" :key="item.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #0000FF">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="2" style="text-align: right">未出现的蓝球：</el-col>
            <el-col :span="22"><span v-for="item in ssqHistoryBlueZeroList" :key="item">{{ item }} </span></el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ssqHistoryOpen=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 下期双色球数字频率弹出层 -->
    <el-dialog :title="ssqNumTitle" :visible.sync="ssqNumOpen" width="1500px" :close-on-click-modal="false">
      <el-row :gutter="10">
        <el-col :span="2" style="text-align: right">红球-红球：</el-col>
        <el-col :span="22">
          <el-row v-for="item in redRedList" :gutter="10" :key="item.num">
            <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :span="2" :key="subItem.num"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span
                  style="color: #d73a49">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider/>
      <el-row :gutter="10">
        <el-col :span="2" style="text-align: right">红球-蓝球：</el-col>
        <el-col :span="22">
          <el-row v-for="item in redBlueList" :key="item.num" :gutter="10">
            <el-col :span="1" style="color: #d73a49;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span
                  style="color: #0000FF">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider/>
      <el-row :gutter="10">
        <el-col :span="2" style="text-align: right">蓝球-红球：</el-col>
        <el-col :span="22">
          <el-row v-for="item in blueRedList" :key="item.num" :gutter="10">
            <el-col :span="1" style="color: #0000FF;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span
                  style="color: #d73a49">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider/>
      <el-row :gutter="10">
        <el-col :span="2" style="text-align: right">蓝球-蓝球：</el-col>
        <el-col :span="22">
          <el-row v-for="item in blueBlueList" :key="item.num" :gutter="10">
            <el-col :span="1" style="color: #0000FF;font-weight: bold">{{ item.num }}：</el-col>
            <el-col :span="23">
              <el-row :gutter="10" style="margin-bottom: 10px">
                <el-col v-for="(subItem,index) in item.numDataList" :key="subItem.num" :span="2"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span
                  style="color: #0000FF">{{ subItem.num }}</span> ({{ subItem.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ssqNumOpen=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  listSsq,
  initAllSsq,
  fillHistoryData,
  getSsqNumData,
  initAllSsqC,
  refreshSsqCache,
  generateSsq,
  getSsqWinningData,
  getNextSsqHistory,
  getNextNumFrequency
} from '@/api/lottery/ssq'
import * as echarts from 'echarts'

export default {
  data() {
    return {
      // 遮罩层
      loading: '',
      showSearch:true,
      //双色球数据
      ssqList: [],
      // 双色球数量
      total: 0,
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        startPeriod: null,
        endPeriod: null,
        redOne: null,
        redTwo: null,
        redThree: null,
        redFour: null,
        redFive: null,
        redSix: null,
        blueOne: null
      },
      countTitle: '',
      countOpen: false,
      redChart: {},
      blueChart: {},
      cTitle: '',
      cOpen: false,
      cForm: {},
      cRules: {
        isC: [
          {required: true, message: '是否不能为空', trigger: 'blur'}
        ]
      },
      generateSsqOpen: false,
      generateSsqForm: {
        count: 1
      },
      generateSsqRules: {
        count: [
          {required: true, message: '个数不能为空', trigger: 'blur'}
        ]
      },
      generateSsqList: [],
      winningList: [],
      winningOpen: false,

      activeSsqHistoryName: 'firstSsq',
      ssqHistoryOpen: false,
      ssqHistoryTitle: '',
      ssqHistoryList: [],
      ssqHistoryRedList: [],
      ssqHistoryRedZeroList: [],
      ssqHistoryBlueList: [],
      ssqHistoryBlueZeroList: [],

      ssqNumTitle: '',
      ssqNumOpen: false,
      redRedList: [],
      redBlueList: [],
      blueRedList: [],
      blueBlueList: [],
    }
  },
  created() {
    this.getSsqList()
  },
  methods: {
    cellClassName({row, column, rowIndex, columnIndex}) {
      if (column.property) {
        if (column.property === 'redOne' || column.property === 'redTwo' || column.property === 'redThree' || column.property === 'redFour' || column.property === 'redFive' || column.property === 'redSix') {
          return 'red-ball';
        } else if (column.property === 'blueOne') {
          return 'blue-ball';
        }
      }
    },
    /** 查询双色球列表 */
    getSsqList() {
      listSsq(this.queryParams).then(res => {
        this.ssqList = res.rows;
        this.total = res.total
      })
    },
    /** 搜索双色球列表 **/
    handleQuerySsq() {
      this.queryParams.current = 1;
      this.getSsqList()
    },
    /** 重置双色球按钮操作 */
    resetQuerySsq() {
      this.queryParams.startPeriod = undefined;
      this.queryParams.endPeriod = undefined;

      this.resetForm("ssqForm");
      this.handleQuerySsq();
    },
    /** 初始化双色球数据 **/
    handleInitAllSsq() {
      this.$modal.confirm("确定要初始化全部双色球数据吗？确认后将全部重新生成！").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在初始化中，请稍后...")
          initAllSsq().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQuerySsq();
          }).catch(() =>  {
            this.$modal.closeLoading()
          })
        }
      }).catch(() => {})
    },
    /** 补全历史数据 **/
    handleFillSsqHistory() {
      this.$modal.confirm("确定要补全双色球历史数据吗？").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在补全中，请稍后...")
          fillHistoryData().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("补全成功")
            this.handleQuerySsq();
          }).catch(() => {
            this.$modal.closeLoading()
          })
        }
      }).catch(() => {
      })
    },
    /** 双色球数据统计折线图 **/
    handleSsqDataLine() {
      this.countTitle = "双色球数据统计柱状图";
      getSsqNumData().then(res => {
        if (res.data.redData.length > 0) {
          let seriesData = res.data.redData.map(item => item.counts);
          let xAxisData = res.data.redData.map(item => item.num);
          this.redChart = echarts.init(this.$refs.redChart, "macarons");
          this.redChart.setOption({
            title: {
              text: '红球数据统计',
              left: 'center'
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross"
              }
            },
            color: ["#ff3c00"],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "0%",
              top: "10%",
              containLabel: true
            },
            xAxis: {
              data: xAxisData
            },
            yAxis: {},
            series: [
              {
                name: "次数",
                type: "bar",
                data: seriesData,
                label: {
                  show: true,
                  position: 'top',
                  formatter: function (data) {
                    return data.value
                  }
                }
              }
            ]
          });
        }
        if (res.data.blueData.length > 0) {
          let seriesData = res.data.blueData.map(item => item.counts);
          let xAxisData = res.data.blueData.map(item => item.num);
          this.blueChart = echarts.init(this.$refs.blueChart, "macarons");
          this.blueChart.setOption({
            title: {
              text: '蓝球数据统计',
              left: 'center'
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross"
              }
            },
            color: ["#0077ff"],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "0%",
              top: "10%",
              containLabel: true
            },
            xAxis: {
              data: xAxisData
            },
            yAxis: {},
            series: [
              {
                name: "次数",
                type: "bar",
                data: seriesData,
                label: {
                  show: true,
                  position: 'top',
                  formatter: function (data) {
                    return data.value
                  }
                }
              }
            ]
          });
        }
      })
      this.countOpen = true;
    },
    /** 导出大双色球按钮操作 */
    handleExportSsq() {
      this.download('/admin/lottery/ssq/export', {
        ...this.queryParams
      }, `双色球导出_${new Date().getTime()}.xlsx`)
    },

    /** 初始化双色球统计数据 **/
    handleInitAllSsqC() {
      this.$modal.confirm("确定要初始化双色球统计数据吗？").then(action => {
        if(action === 'confirm'){
          this.$modal.loading("正在初始化中，请稍后...")
          initAllSsqC().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQuerySsq();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=>{ })
    },
    /** 刷新双色球缓存 **/
    handleRefreshSsq() {
      refreshSsqCache().then(() => {
        this.$modal.msgSuccess("刷新成功");
      })
    },
    /** 打开生成双色球弹窗 */
    handleOpenGenerateSsq() {
      this.generateSsqOpen = true;
      this.$set(this.generateSsqForm, 'count', 1)
      this.resetForm("generateSsqForm");
      this.generateSsqList = []
    },
    handleGenerateSsq() {
      this.$refs["generateSsqForm"].validate(valid => {
        if (valid) {
          generateSsq(this.generateSsqForm).then(res => {
            if (res.flag) {
              this.generateSsqList = res.data
            }
          })
        }
      })
    },
    resetGenerateSsq() {
      this.generateSsqList = []
      this.$set(this.generateSsqForm, 'count', 1)
      this.resetForm("generateSsqForm");
    },
    /** 获奖概率弹窗 **/
    handleWinning(row) {
      this.winningList = [];
      let queryParams = {
        redOne: row.redOne,
        redTwo: row.redTwo,
        redThree: row.redThree,
        redFour: row.redFour,
        redFive: row.redFive,
        redSix: row.redSix,
        blueOne: row.blueOne,
        period: row.period
      }
      getSsqWinningData(queryParams).then(res => {
        this.winningList = res.data
        this.winningOpen = true;
      })
    },
    /** 下期历史同期数据 **/
    handleNextHistory(period) {
      this.ssqHistoryList = [];
      this.ssqHistoryRedList = [];
      this.ssqHistoryRedZeroList = [];
      this.ssqHistoryBlueList = [];
      this.ssqHistoryBlueZeroList = [];
      getNextSsqHistory(period).then(res => {
        this.ssqHistoryList = res.data.lotteryDataList;
        this.ssqHistoryRedList = res.data.redList;
        this.ssqHistoryRedZeroList = res.data.redZeroList;
        this.ssqHistoryBlueList = res.data.blueList;
        this.ssqHistoryBlueZeroList = res.data.blueZeroList;
        this.ssqHistoryTitle = "【" + res.data.period + "】期双色球历史同期统计";
        this.ssqHistoryOpen = true;
      })
    },
    /** 打开导出彩票统计次数弹窗 **/
    handleOpenC() {
      this.cOpen = true;
      this.cTitle = "双色球统计数据导出";
    },
    /** 导出统计次数 **/
    exportC() {
      this.$refs["cForm"].validate(valid => {
        if (valid) {
          this.download('/admin/lottery/ssq/exportC', {
            ...this.cForm
          }, `双色球统计数据导出_${new Date().getTime()}.xlsx`)
        }
      });
    },
    cancelC() {
      this.cOpen = false;
      this.cForm = {};
      this.resetForm("cForm");
    },
    countClosed() {
      this.redChart.dispose();
      this.blueChart.dispose();
    },
    close() {
      this.generateSsqOpen = false;
    },
    exportFrequency() {
      this.download('/admin/lottery/ssq/exportFrequency', {
        ...this.queryParams
      }, `双色球数字组合频率导出_${new Date().getTime()}.xlsx`)
    },

    handleNextNum(period) {
      this.redRedList = [];
      this.redBlueList = [];
      this.blueRedList = [];
      this.blueBlueList = [];
      this.ssqNumTitle = "【" + period + "】期双色球下期数字频率";
      let params = {period: period, count: null}
      getNextNumFrequency(params).then(res => {
        this.redRedList = res.data.redRedList;
        this.redBlueList = res.data.redBlueList;
        this.blueRedList = res.data.blueRedList;
        this.blueBlueList = res.data.blueBlueList;
        this.ssqNumOpen = true;
      })
    }
  }
}
</script>

